import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { listBankPayment, getlistBankInfoAdmin } from '../../../../actions/adminPageAction';
import copy from 'copy-text-to-clipboard';
import History from './history';
import Swal from 'sweetalert2';
import NumberFormat from 'react-number-format';
class NapTien extends Component {

    state = {
        checkTab: 0
    }
    componentDidMount(){
		var listBankPayment_config = localStorage.getItem("listBankPayment");
		if (listBankPayment_config == null) {
			this.props.listBankPayment();
		} else {
			listBankPayment_config = JSON.parse(listBankPayment_config);
			if (typeof listBankPayment_config.checktime === 'undefined') {
				this.props.listBankPayment();
			} else {
				if ((parseInt(Date.now() / 1000) - listBankPayment_config.checktime > 1)) {
					this.props.listBankPayment();
				}
			}
		}
        this.props.getlistBankInfoAdmin();
    }
    openTabMenu = (e, data) => {
        e.preventDefault();
        this.setState({
            checkTab: data,
        });
    }
    copyID(text) {
        copy(text);
        Swal.fire({
            icon: 'success',
            title: '',
            text: 'Đã copy!',
        });
        return false;
    }
    render() {
        const {checkTab} = this.state;
        const {loadding} = this.props.buffviewsvideo;
        const { listbankinfo } = this.props.adminpage;
		var listbankpayment = {};
		if (localStorage.getItem("listBankPayment") != null) {
			listbankpayment = JSON.parse(localStorage.getItem("listBankPayment"));
		} else {
			listbankpayment = this.props.adminpage.listbankpayment;
		}
		var config_website = {};
		if (localStorage.getItem("confignavbar") != null) {
			config_website = JSON.parse(localStorage.getItem("confignavbar"));
		} else {
			config_website = this.props.auth.config_website;
		}
        var cuphapnaptien = '';
        if (listbankpayment.noidung !== '') {
            cuphapnaptien = listbankpayment.noidung.replace('{user_name}',this.props.auth.user.username);
            cuphapnaptien = cuphapnaptien.replace('{id}',this.props.auth.user.id);
        }
		var html_bankinfo = [];
		var that = this;
		listbankinfo.forEach(function(v, i) {
			html_bankinfo.push(
				<div className="col-md-6" key={i}>
					<div className="card-naptien-cus mb-4">
						<div className="card-header-cus" style={{"color": "rgb(0, 97, 242)", "fontWeight": "700", "fontSize": "1.2rem"}}>Nạp qua ngân hàng</div>
						<div className=" card-body">
							<ul className="list-group">
								<li className="list-group-item d-flex justify-content-between align-items-center">
									Số tài khoản:
									<span className="badge badge-cus bg-primary rounded-pill">{v.sotaikhoan}</span>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-center">
									Tên tài khoản:
									<span className="badge badge-cus bg-primary rounded-pill">{v.tentaikhoan}</span>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-center">
									Ngân hàng:
									<span className="badge badge-cus bg-primary rounded-pill">{v.nganhang}</span>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-center">
									Chi nhánh:
									<span className="badge badge-cus bg-primary rounded-pill">{v.chinhanh}</span>
								</li>
								{
									v.gionapnhanh != '' && v.gionapnhanh != null ?
										(
											<li className="list-group-item d-flex justify-content-between align-items-center">
												Giờ nạp nhanh:
												<span className="badge badge-cus bg-primary rounded-pill">{v.gionapnhanh}</span>
											</li>
										)
									: ''
								}
							</ul>
							<div className="form-group" style={{"marginTop": "10px"}}>
								<button className="btn btn-primary" onClick={()=>{that.copyID(v.sotaikhoan)}}>
									COPY
								</button>
							</div>
						</div>
					</div>
				</div>
			);
		})
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className={"block block-bordered shadow"+ (loadding? ' block-mode-loading' : '')}>
							<div className="card-header-cus border-bottom">
								<ul className="nav nav-tabs nav-tabs-block">
									<li onClick={(e) => {this.openTabMenu(e, 0)}} className="nav-item zxc licus">
										<a className={'nav-link'+ (checkTab === 0 ? ' active' : '')} href="/#">
											Nạp Tiền
										</a>
									</li>
									<li onClick={(e) => {this.openTabMenu(e, 1)}} className="nav-item zxc licus">
										<a className={'nav-link' + (checkTab === 1 ? ' active' : '')} href="/#">
											Nhật Ký Nạp Tiền
										</a>
									</li>
								</ul>
							</div>
                            <div className="block-content tab-content overflow-hidden">
                                {checkTab === 0 ? 
                                    <div className='tab-pane fade fade-left show active'>
										<div id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" className="tab-pane fade show active">
											<div className="col-md-12">
												<div className="col-md-12">
													<div className="form-group">
														{
															config_website.naptien_mota == "" ?
																<Fragment>
																	<h4 >Tỷ giá: 1 VND = 1 Coin</h4>
																	<p >
																		- Cộng Tác Viên : Giảm 30 giá tất cả các chức năng ( Nạp hoặc Chi tiêu từ 300.000 coin )
																	</p>
																	<p >
																		- Đại Lý : Giảm 70 giá tất cả các chức năng ( Nạp hoặc Chi tiêu từ 1.000.000 coin )
																	</p>
																	<p >
																		Bạn vui lòng chuyển khoản chính xác nội dung chuyển khoản bên dưới hệ thống sẽ tự động cộng tiền cho bạn sau khi nhận được tiền. Nếu sau 10 phút từ khi tiền trong tài khoản của bạn bị trừ mà bạn vẫn chưa được cộng tiền vui lòng liên hệ hỗ trợ.
																	</p>
																</Fragment>
															: 
																<Fragment>
																	<h4 style={{"whiteSpace": "pre-wrap"}}>{config_website.naptien_mota}</h4>
																</Fragment>
														}
													</div>
												</div>
												<div className="col-md-12 row">
													<div className="col-md-6">
														<div className="card-naptien-cus mb-4">
                                                            <div className="card-header-cus" style={{"color": "rgb(0, 97, 242)", "fontWeight": "700", "fontSize": "1.2rem"}}>Nạp qua ngân hàng</div>
                                                            <div className=" card-body">
                                                                <ul className="list-group">
                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Số tài khoản:
                                                                        <span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.sotaikhoan}</span>
                                                                    </li>
                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Tên tài khoản:
                                                                        <span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.tentaikhoan}</span>
                                                                    </li>
                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Ngân hàng:
                                                                        <span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.nganhang}</span>
                                                                    </li>
                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Chi nhánh:
                                                                        <span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.address_bank}</span>
                                                                    </li>
                                                                </ul>
                                                                <div className="form-group" style={{"marginTop": "10px"}}>
																	<button className="btn btn-primary" onClick={()=>{this.copyID(listbankpayment.sotaikhoan)}}>
																		COPY
																	</button>
                                                                </div>
                                                            </div>
                                                        </div>
													</div>
													<div className="col-md-6">
														<div className="card-naptien-cus mb-4">
                                                            <div className="card-header-cus" style={{"color": "rgb(0, 97, 242)", "fontWeight": "700", "fontSize": "1.2rem"}}>Nội dung nạp tiền</div>
                                                            <div className=" card-body">
                                                                <div className="form-group">
                                                                    <input type="text" name="huongdan_1" className="form-control" value={cuphapnaptien} disabled />
                                                                </div>
                                                                <div className="form-group" style={{"marginTop": "10px"}}>
                                                                    <button className="btn btn-primary" style={{"width": "100%"}} onClick={()=>{this.copyID(cuphapnaptien)}}>
																		COPY
																	</button>
                                                                </div>
                                                            </div>
                                                        </div>
													</div>
													{
														listbankpayment.tentaikhoan_momo != '' || listbankpayment.phone_momo != '' ?
															<div className="col-md-6">
																<div className="card-naptien-cus mb-4">
																	<div className="card-header-cus" style={{"color": "rgb(0, 97, 242)", "fontWeight": "700", "fontSize": "1.2rem"}}>Nạp qua Momo</div>
																	<div className=" card-body">
																		<ul className="list-group">
																			<li className="list-group-item d-flex justify-content-between align-items-center">
																				Tên tài khoản:
																				<span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.tentaikhoan_momo}</span>
																			</li>
																			<li className="list-group-item d-flex justify-content-between align-items-center">
																				Số điện thoại:
																				<span className="badge badge-cus bg-primary rounded-pill">{listbankpayment.phone_momo}</span>
																			</li>
																		</ul>
																		<div className="form-group" style={{"marginTop": "10px"}}>
																			<button className="btn btn-primary" onClick={()=>{this.copyID(listbankpayment.phone_momo)}}>
																				COPY
																			</button>
																		</div>
																	</div>
																</div>
															</div>
														: ''
													}
													{html_bankinfo}
												</div>
												<div className="col-lg-12">
													<div className="card-naptien-cus mb-4">
														<div className="card-header-cus" style={{"color": "rgb(0, 97, 242)", "fontWeight": "700", "fontSize": "1.2rem"}}>Chú ý:</div>
														<div className=" card-body">
															{
																config_website.naptien_chuy == "" ?
																	<Fragment>
																		<p>- Nạp sai cú pháp hoặc sai số tài khoản sẽ bị trừ 10% phí giao dịch, tối đa trừ 50.000 Coin. Ví dụ nạp sai 100.000 trừ 10.000, 200.000 trừ 20.000, 500.000 trừ 50.000, 1 triệu trừ 50.000, 10 triệu trừ 50.000...</p>
																		<p>- Số tiền chuyển khoản tối thiểu 1 lần là 50,000 VNĐ</p>
																	</Fragment>
																: 
																	<Fragment>
																		<h6 className="font-bold text-danger mb-0" style={{"padding":"20px", "whiteSpace": "pre-wrap"}}>{config_website.naptien_chuy}</h6>
																	</Fragment>
															}
														</div>
													</div>
												</div>
											</div>
                                        </div>
                                    </div>
                                :
                                    <div className='tab-pane fade fade-left show active show active'>
                                        <History />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    adminpage: state.adminpage,
    buffviewsvideo: state.buffviewsvideo
});

export default connect(mapStateToProps, { listBankPayment, getlistBankInfoAdmin }) (NapTien);
